import { storyUrl } from './storyLinks.js';
import { shareLink } from './nativeShare.js';
import { isNativeApp } from './platform.js';

const SHARE_PREFIX = {
  en: 'Read on Repatikosam',
  te: 'రేపటికోసం లో చదవండి',
  ta: 'ரேபதிகோசம்-இல் படியுங்கள்',
  kn: 'ರೇಪಟಿಕೋಸಂನಲ್ಲಿ ಓದಿ',
};

/**
 * Share a story. On native uses the system share sheet; elsewhere WhatsApp.
 */
export async function shareStoryOnWhatsApp(title, storyId, lang = 'te') {
  const url = storyUrl(storyId);
  const prefix = SHARE_PREFIX[lang] || SHARE_PREFIX.te;
  const headline = String(title || '').trim();
  const text = headline ? `${headline}\n${prefix}` : prefix;

  if (isNativeApp()) {
    await shareLink({ title: headline || 'Repatikosam', text, url });
    return;
  }

  const body = headline ? `${headline}\n${prefix}\n\n${url}` : `${prefix}\n\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(body)}`, '_blank', 'noopener');
}
